module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "50px"
    }
  }, [_c('el-input', {
    staticClass: "area",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "输入快递单号",
      "clearable": ""
    },
    on: {
      "input": _vm.inputHandler
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('div', [_vm._v("单号：" + _vm._s(_vm.keyword))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://wuji-airport.oss-cn-hangzhou.aliyuncs.com/100k0y000000lzekl0155_C_500_280.jpg"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3336be13"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/demo.vue
// module id = 1232
// module chunks = 2